import React from 'react';

// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-redeclare
import { MainContent, Message } from './LoadingPage.styled';
import { LoadingIndicator } from '../LoadingIndicator/LoadingIndicator';

export interface ILoadingPageProps {
  message: string;
}

const LoadingPage: React.FC<ILoadingPageProps> = (props) => {
  return (
    <MainContent data-testid='LoadingPage'>
      <Message> {props.message}</Message>
      <LoadingIndicator />
    </MainContent>
  );
};

export default LoadingPage;
